/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { EvalDimRating } from './evalDimRating';

/**
 * Evaluation result of a submission represented as a mapping from dimension names to EvalDimRating.
 */
export interface TaskSubmissionEvaluation {
  [key: string]: EvalDimRating;
}
